// extracted by mini-css-extract-plugin
var _1 = "StickyHeader-module__animateUploadProgressBarWidth--ujUqC";
var _2 = "StickyHeader-module__animatedBackground--J86vF";
var _3 = "StickyHeader-module__container--iflOn";
var _4 = "StickyHeader-module__header--RQyfL";
var _5 = "StickyHeader-module__stuck--uz8NE";
var _6 = "StickyHeader-module__topbarAware--BGpga";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "header", _5 as "stuck", _6 as "topbarAware" }
